import * as z from "zod";

export const respondToAeoAssistantTool = {
  name: "respondToAeoAssistantTool" as const,
  input: z.object({
    threadId: z.string(),
    toolCallId: z.string(),
    result: z.unknown(),
  }),
  output: z.object({ success: z.boolean() }),
};
